module.exports = __webpack_public_path__ + "static/media/4ODA11.2526429c.jpg";